export const ALLERGENS_14 = [
  "celery",
  "cereals containing gluten",
  "crustaceans",
  "eggs",
  "fish",
  "lupin",
  "milk",
  "molluscs",
  "mustard",
  "nuts",
  "peanuts",
  "sesame",
  "soya",
  "sulphites",
];

export const DIETARY_LABELS = [
  "vegetarian",
  "vegan",
  "gluten-free",
  "dairy-free",
  "egg-free",
  "nut-free",
  "soya-free",
];

export const ALLERGEN_DECLARATION_STATUSES = [
  "unreviewed",
  "contains_regulated_allergens",
  "none_of_14_as_ingredients",
];

// Single source of truth for customer-facing allergen wording — never say
// "allergen-free", "free from allergens" or "safe for allergy sufferers".
export function declarationDisplayText(item) {
  const status = item?.allergen_declaration_status || (item?.allergens?.length ? "contains_regulated_allergens" : "unreviewed");
  if (status === "contains_regulated_allergens" && item.allergens?.length) {
    return `Contains: ${item.allergens.join(", ")}.`;
  }
  if (status === "none_of_14_as_ingredients") {
    return "No UK 14 regulated allergens are used as ingredients.";
  }
  return null; // unreviewed — callers show the "being confirmed" copy instead
}

export function mayContainDisplayText(item) {
  return item?.may_contain?.length
    ? `May contain: ${item.may_contain.join(", ")} due to preparation in a kitchen that handles these allergens.`
    : null;
}

export const inputClass =
  "w-full rounded-xl border border-choco-line bg-choco px-4 py-2.5 text-sm text-cream-text placeholder:text-cream-muted/60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-focus";

export const labelClass = "mb-1.5 block text-sm font-semibold text-cream-text";
